import * as MetaReducers from './msal-auth.metareducer';
import * as Reducers from './msal-auth.reducer';

export const MsalAuthReducers = {
  Reducers,
  MetaReducers,
};
